import { z } from 'zod';

export const shippingNumberSearchSchema = z.object({
  number: z
    .number()
    .int('El número de pedido debe ser un entero')
    .positive('El número de pedido debe ser mayor a 0'),
});

export type ShippingNumberSearchInput = z.infer<typeof shippingNumberSearchSchema>;
